var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"app-bar-home-link",attrs:{"to":"/"}},[_c('img',{attrs:{"src":require("@/assets/logo_capital_partners_alt.svg"),"alt":"Loyall Capital Partners","height":"36"}})])}
var staticRenderFns = []

export { render, staticRenderFns }